import Postmate from 'postmate'
import { assignColorsToCssVariables } from '@/helpers/colors'

export default class DesignerReceiver {
  constructor(eventBus, token, updater) {
    this.eventBus = eventBus
    this.token = token
    this.settingsUpdater = updater
    this.handshake = null
    this.parent = null
  }

  start() {
    return new Promise((resolve, reject) => {
      this.parent = null
      this.handshake = this.initHandshake()

      this.handshake
        .then((parent) => {
          this.parent = parent

          resolve(parent)
        })
        .catch(err => reject(err))
    })
  }

  initHandshake() {
    return new Postmate.Model({
      token: this.token,
      updateSetting: ({ path, value }) => this.settingsUpdater({ path, value }),
      updateColors: ({ colors }) => this.updateColors(colors),
      highlightNamespaceSection: ({ namespace }) => this.highlightNamespaceSection(namespace),
      removeHighlightFromNamespaceSection: ({ namespace }) => this.removeHighlightFromNamespaceSection(namespace),
    })
  }

  highlightNamespaceSection(namespace) {
    this.eventBus.$emit(`designer:highlight:${namespace}:apply`)
    this.eventBus.$emit(`designer:highlight:apply`, namespace)
  }

  removeHighlightFromNamespaceSection(namespace) {
    this.eventBus.$emit(`designer:highlight:${namespace}:remove`)
    this.eventBus.$emit(`designer:highlight:remove`, namespace)
  }

  updateColors(colors) {
    assignColorsToCssVariables(colors)
  }

  updateSettingsVia(handler) {
    this.settingsUpdater = handler
  }

  pageUpdated(name, attempt = 1) {
    if (!this.parent) {
      if (attempt > 10) {
        return
      }

      return setTimeout(() => this.pageUpdated(name, attempt + 1), 500)
    }

    this.parent.emit('page.updated', name)
  }
}
